import React from 'react'
import type { Icon } from 'shared/utils'

type Props = {
    ...Icon,
    small?: boolean
}

const CirclePlus = (props: Props) => {
    const {
        color = 'black',
        background = 'white',
        stroke = 'white',
        size = 40,
        className = 'circle-plus',
        small = false
    } = props

    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 40 40"
            preserveAspectRatio="none">
            <g fill="none" fillRule="evenodd">
                <circle
                    cx={20}
                    cy={20}
                    r={small ? 13 : 20}
                    fill={background}
                    stroke={stroke}
                />
                <path
                    fill={color}
                    d="M21.332 19.249v-6.207a1.04 1.04 0 1 0-2.083 0v6.207h-6.207a1.04 1.04 0 1 0 0 2.083h6.207v6.207a1.04 1.04 0 1 0 2.083 0v-6.207h6.207a1.04 1.04 0 1 0 0-2.083h-6.207z"
                />
            </g>
        </svg>
    )
}

export { CirclePlus }
